const addSpeculationRulesScript = (id, urlsToPrerender = [], eagerness = 'moderate', type) => {
    if (!HTMLScriptElement.supports('speculationrules')) return;

    const specScript = document.createElement('script');
    specScript.type = 'speculationrules';
    specScript.id = id;
    specScript.text = `{"${type}":[{"source": "list",
                      "urls": ["${urlsToPrerender.join('","')}"],
                      "eagerness": "${eagerness}"}]}`;
    try {
        document.head.appendChild(specScript);
    } catch (error) {
        return error;
    }
};

export const addSpeculationRulesPrerender = (id, urlsToPrerender = [], eagerness ) => {
    return addSpeculationRulesScript(id, urlsToPrerender, eagerness, 'prerender');
};

export const addSpeculationRulesPrefetch = (id, urlsToPrerender = [], eagerness ) => {
    return addSpeculationRulesScript(id, urlsToPrerender, eagerness, 'prefetch');
};
